import * as amplitude from "@amplitude/analytics-browser"
import { Metric, onCLS, onFCP, onINP, onLCP, onTTFB } from "web-vitals"

export default function analyticsWebVitals() {
  function sendToAnalytics(metric: Metric) {
    amplitude.track("Marketing Web Vitals", {
      Type: metric.name,
      Value: metric.value,
      Rating: metric.rating,
      Delta: metric.delta,
      "Navigation type": metric.navigationType,
    })
  }

  onCLS(sendToAnalytics)
  onFCP(sendToAnalytics)
  onINP(sendToAnalytics)
  onLCP(sendToAnalytics)
  onTTFB(sendToAnalytics)
}
